import { useEffect } from 'react';
import { useIntl } from 'react-intl';

import { useCountrySelect } from '../../../../../hocs/useCountrySelect';

import { ISO_CODES } from '../../../../../constants/lang';

const useCountryData = () => {
  const { formatMessage } = useIntl();

  const {
    isZipApplicable,
    loadCountryDetails,
    stateList,
    zipLimit,
  } = useCountrySelect(formatMessage);

  useEffect(() => {
    loadCountryDetails(ISO_CODES.US);
  }, []);

  return {
    stateList,
    zipLimit,
    isZipApplicable,
  };
};

export default useCountryData;



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/InsuranceDetails/PrimarySubscriberFormSection/hooks/useCountryData.js